module.exports = __webpack_public_path__ + "media/images/e-bilet/train-7de05069a7ca2f2152edea21f6bb8af7.svg";